// @flow
import type { RaceStatusEnum } from "@tvg/types/Race";
import mediator from "@tvg/mediator";
import { get } from "lodash";
import type { Props } from "../components/Program";

export const getModuleGTM = (prevPath: string = ""): string => {
  if (prevPath.includes("/home") || prevPath === "/") {
    return "Home Page";
  }

  if (prevPath.includes("/tracks")) {
    return "tracks";
  }

  if (prevPath.includes("/live")) {
    return "live";
  }

  if (prevPath.includes("/racetracks") || prevPath.includes("/greyhound")) {
    return "Race Modal";
  }

  return "";
};

export const getStatusGTM = (data: {
  status: RaceStatusEnum,
  mtp: number
}): string | number => {
  switch (get(data, "status")) {
    case "SK":
      return "Race Off";
    case "RO":
      return "Result";
    default:
      return get(data, "mtp");
  }
};

export const getMtpGTMHomePageNavigation = (data: {
  status: RaceStatusEnum,
  mtp: number
}): string | number => {
  if (
    data.mtp < 60 &&
    get(data, "status") !== "SK" &&
    get(data, "status") !== "RO"
  ) {
    return ` - ${data.mtp}`;
  }

  switch (get(data, "status")) {
    case "SK":
      return " - Race Off";
    case "RO":
      return " - Result";
    default:
      return "";
  }
};

export const getTagGTMHomePageNavigation = (
  onTvg: boolean,
  onTvg2: boolean
): string => {
  let res = "no tag";
  if (onTvg) {
    res = "onTvg";
  } else if (onTvg2) {
    res = "onTvg2";
  }
  return res;
};

export const livePageNavigation = (
  thisProps: Props,
  nextProps: Props
): void => {
  const channel = get(nextProps, "match.params.channel", "");
  if (
    get(thisProps, "currentRace.id") !== get(nextProps, "currentRace.id") &&
    getModuleGTM(get(nextProps, "prevPath")) !== "live" &&
    getModuleGTM(get(nextProps, "prevPath")) !== "Home Page"
  ) {
    // gtm for navigation by race selector inside the program page
    mediator.base.dispatch({
      type: "LIVE_PAGE_NAVIGATION",
      payload: {
        channel,
        destinationUrl: get(nextProps, "location.pathname")
      }
    });
  }
};

export const programPageNavigation = (
  thisProps: Props,
  nextProps: Props,
  isArrowNavigationChange: boolean = false
): void => {
  if (
    get(thisProps, "currentRace.id") !== get(nextProps, "currentRace.id") &&
    getModuleGTM(get(nextProps, "prevPath")) !== "tracks"
  ) {
    // gtm for navigation by race selector inside the program page
    mediator.base.dispatch({
      type: "RACE_NAVIGATION",
      payload: {
        trackName: get(nextProps, "currentRace.track.trackName"),
        raceNumber: get(nextProps, "currentRace.raceNumber"),
        mtp: ` - ${getStatusGTM({
          status: get(nextProps, "currentRace.status.code"),
          mtp: get(nextProps, "currentRace.mtp")
        })}`,
        module: isArrowNavigationChange
          ? "Race to Race"
          : getModuleGTM(get(nextProps, "prevPath")),
        runnerType: get(nextProps, "currentRace.isGreyhound")
          ? "Greyhounds"
          : "Horse",
        url: get(nextProps, "location.pathname"),
        tag: undefined
      }
    });
  }
};
